//External libraries
import React from 'react';
import { string } from 'prop-types';

//Internal modules
import { features, getContent } from '@/lib';
import { handleLanguageChange } from '../shared';
import { useMountLogging } from '@/lib/reactHooks';
import { LanguageButton, LanguageListContainer } from './StyledComponents';

const LanguageList = ({ currLanguage }) => {
  useMountLogging('LanguageList');

  return (
    <LanguageListContainer>
      {features.config.enabledLanguages
        .filter(lang => lang !== currLanguage)
        .map(lang => (
          <LanguageButton key={lang} onClick={() => handleLanguageChange(lang)}>
            {getContent(`languages.${lang}`)}
          </LanguageButton>
        ))}
    </LanguageListContainer>
  );
};

LanguageList.propTypes = {
  currLanguage: string,
};

export { LanguageList };
